import 'owa-shared-bootstrap/lib/polyfills';
import 'owa-application/lib/styles/index'; // Import owa-application styles here to include globalStyles

export { default as getPeopleBootstrapOptions } from './getPeopleBootstrapOptions';
import 'owa-calendar-module-selected-calendars-user-config';
